<template>
  <b-modal ref="taskActions" centered id="taskActions" hide-header hide-footer>
    <h1 class="edit-task-header text-left">Edit Selected Tasks</h1>
    <hr>
    <b-form class="text-left" @submit.stop.prevent="updateTasks">
      <div class="col-xs-12">
          Client:
          <v-select v-model="newClient" :options="clients" class="mb-3"/>
      </div>
      <div class="col-xs-12">
          Status:
          <b-form-select v-model="newStatus" :options="selectedTasks[0].statuses" class="mb-3"/>
      </div>
      <div class="col-xs-12">
          Owner:
          <SingleUserSelector v-on:user-change="newOwner = $event" v-on:user-remove="newOwner = {}" :parentPath="'task'" class="mb-3"/>
      </div>
      <div class="col-xs-12">
          Priority:
          <b-form-select v-model="newPriority" :options="selectedTasks[0].priorities" class="mb-3"/>
      </div>
      <br>
      <b-button class="edit-task-btn" type="submit">Submit</b-button>

      <b-btn class="close-task-btn float-right" @click="hideModal">Close</b-btn>
      <b-btn class="close-task-btn btn-danger float-right mr-2" @click="deleteTasks">Delete All</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import { collectionsMixins } from '@/mixins/collectionsMixins'
import { mapGetters } from 'vuex'
import SingleUserSelector from './selectors/users/SingleUserSelector.vue'

export default {
  name: 'TaskActions',
  mixins: [collectionsMixins],
  props: {
    ticket: Object,
    selectedTasks: Array
  },
  components: {
    SingleUserSelector
  },
  data () {
    return {
      newClient: null,
      newStatus: null,
      newOwner: null,
      newPriority: null,
      selected: null
    }
  },

  computed: {
    ...mapGetters(['clients'])
  },

  methods: {
    updateTasks () {
      var vm = this
      this.selectedTasks.forEach((item) => {
        if (vm.newClient !== null) {
          item.client_object = vm.newClient
          item.client_id = item.client_object.value
        }
        if (vm.newStatus !== null) {
          item.status = vm.newStatus
        }
        if (vm.newOwner !== null) {
          item.owner = vm.newOwner
        }
        if (vm.newPriority !== null) {
          item.priority = vm.newPriority
        }
        this.updateTask(item)
      })
    },
    updateTask (item) {
      this.$http.put('/tasks/' + item.id, { task: item })
        .then(response => this.submitSuccessful(response, item.ticket_id))
        .catch(e => { console.log(e.response) })
    },
    deleteTasks () {
      var del = confirm('Are you sure you want to delete all selected tasks?')
      if (del === true) {
        this.selectedTasks.forEach((item) => {
          this.deleteTask(item)
        })
      }
    },
    deleteTask (item) {
      var vm = this
      this.$http.delete('/tasks/' + item.id)
        .then(function (response) {
          vm.submitSuccessful(response, item.ticket_id)
        })
        .catch(e => { console.log(e) })
    },
    submitSuccessful (response, ticketId) {
      this.$root.$emit('reloadTasks', ticketId)
      this.hideModal()
    },
    hideModal () {
      this.resetForm()
      this.$root.$emit('bv::hide::modal', 'taskActions')
    },
    resetForm () {
      this.newClient = null
      this.newStatus = null
      this.newOwner = null
      this.newPriority = null
    }
  }
}
</script>

<style scoped>
#editTask h1 {
  color: #6c757d;
  font-weight: bold;
}
#editTask li {
  display: inline-block;
  margin-right: 20px;
}
#editTask li a {
  color: #6c757d;
  text-decoration: none;
}
#editTask li a:hover {
  border-bottom: 3px solid #57B2CD;
  margin-top: -4px;
}
#editTask ul {
  padding-left: 10px;
}
#editTask .form-control {
  margin-bottom: 20px;
}
#editTask .radio-desc {
  margin-left: 30px;
  opacity: .5;
}
.edit-task-btn {
  background-color: #57B2CD;
  border-color: #57B2CD;
}
.edit-task-btn:hover {
  background-color: #3D92AB;
}
.modal-content {
  max-width: 600px;
  margin: 0 auto;
  padding: 10px;
}
.hidden-checkbox {
    margin-bottom: 25px;
    margin-left: 10px;
}
.team-view-check {
  padding-left: 30px;
  padding-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/TaskActions.vue